import { AxiosError } from "axios";

import { api } from "@/lib/axios";

import {
	UpdateHelpQuestionError,
	UpdateHelpQuestionRequest,
	UpdateHelpQuestionResponse,
} from "./help-topics";

export async function updateHelpQuestion(
	hash: string,
	data: UpdateHelpQuestionRequest,
): Promise<
	| { status: "success"; data: UpdateHelpQuestionResponse }
	| { status: "error"; errors: UpdateHelpQuestionError }
> {
	try {
		const response = await api.put<UpdateHelpQuestionResponse>(
			`/help-question/update/${hash}`,
			data,
		);

		return {
			status: "success",
			data: response.data,
		};
	} catch (error) {
		const axiosError = error as AxiosError<UpdateHelpQuestionError>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data,
			};
		}

		return {
			status: "error",
			errors: {
				message: "An unknown error occurred. Please try again later.",
				errors: {
					unknown: ["An unknown error occurred. Please try again later."],
				},
			},
		};
	}
}
